$(document).ready(function() {
    // Define the two prices
    var price1 = '150';
    var price2 = '300';
    var currentPrice = price1;
    // Function to toggle the text between the two prices
    function togglePrice() {
        if (currentPrice === price1) currentPrice = price2;
        else currentPrice = price1;
        $('#pricing').text(currentPrice);
    }
    // Attach a click event handler to the button
    $('#toggleButton').click(function() {
        togglePrice();
    });
});

//# sourceMappingURL=accounting-for-plumbers.e7545263.js.map
